import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-epb-gazoprovodov',
  templateUrl: './epb-gazoprovodov.component.html',
  styleUrls: ['./epb-gazoprovodov.component.scss']
})
export class EpbGazoprovodovComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
